import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { categoryData } from "../../../../../../redux/slices/categorySlice";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  queryToUrl,
  setUrl,
  urlToQuery,
} from "../../../../../helper/utils";
import {
  closeIcon,
  prevVIcon,
  searchIcon,
  downVIcon,
} from "../../../../../assets/icons";

const Categories = ({ setContentId, setPage, isAlibabaSearch }) => {
  const [search, SetSearch] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [queryArray, setQueryArray] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [sliceVal, setSliceVal] = useState(9);
  const [showSubCategories, setShowSubCategories] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();
  const searchRef = useRef();
  const allCategories = useSelector(categoryData);

  useEffect(() => {
    // Skip category processing during Alibaba searches
    if (isAlibabaSearch) {
      console.log('Skipping category list initialization during Alibaba search');
      return;
    }
    
    try {
      if (Array.isArray(allCategories)) {
        // Filter out any null or undefined items
        const validCategories = allCategories.filter(cat => cat && cat.c_name);
        setCategoryList(validCategories);
      } else {
        setCategoryList([]);
      }
    } catch (error) {
      console.error('setCategoryList error:', error);
      setCategoryList([]);
    }
  }, [allCategories, isAlibabaSearch]);

  useEffect(() => {
    if (searchParams.get("category")) {
      setQueryArray(
        urlToQuery(searchParams.get("category"))
          .split("/")
          .filter((item) => item !== "")
      );
    } else {
      setQueryArray([]);
    }

    setSearchVal("");
  }, [location]);

  useEffect(() => {
    if (queryArray.length) {
      handleCategoryByLocation(queryArray);
    } else {
      setSelectedCategories([]);
      setCategoryList(allCategories);
    }
  }, [queryArray]);

  const handleSearch = (val) => {
    SetSearch(val);
  };

  const selectCategory = (item, index) => {
    try {
      if (!item?.c_name) {
        console.error('selectCategory: item or c_name is null/undefined');
        return;
      }

      // Check if this is a final category (leaf node) - no children or empty children array
      const isFinalCategory = !item.children || !Array.isArray(item.children) || item.children.length === 0;
      
      // If it's a final category, navigate to the new route format
      if (isFinalCategory) {
        const categoryName = item.c_name.toLowerCase().trim();
        if (categoryName) {
          navigate(`/collection?ali=keyword&search=${encodeURIComponent(categoryName)}&category=global`);
          setPage(1);
          return;
        }
      }

      // If not a final category, continue with existing navigation logic
      if (!queryArray.some((category) => category === item.c_name)) {
        const value = `${ 
          queryToUrl(queryArray.join("/")) +
          (queryArray.length ? "/" : "") +
          queryToUrl(item.c_name)
        }`;
        navigate(setUrl(location.pathname, searchParams, "category", value));
        setPage(1);
      } else {
        if (queryArray.length - 1 === index) {
          setShowSubCategories(!showSubCategories);
        } else {
          setPage(1);
          setShowSubCategories(true);
          const activeIndex = queryArray.findIndex((val) => val === item.c_name);
          const sliceArray = queryArray.slice(0, activeIndex + 1);
          const value = `${queryToUrl(sliceArray.join("/"))}`;
          navigate(setUrl(location.pathname, searchParams, "category", value));
        }
      }
    } catch (error) {
      console.error('selectCategory error:', error);
    }
  };

  const handleBack = (item, index) => {
    try {
      setPage(1);
      if (!item?.c_name) {
        console.error('handleBack: item or c_name is null/undefined');
        return;
      }

      if (index !== 0) {
        setShowSubCategories(true);
        const activeIndex = queryArray.findIndex((val) => val === item.c_name);
        const sliceArray = queryArray.slice(0, activeIndex);
        const value = `${queryToUrl(sliceArray.join("/"))}`;

        console.log('value',value)
        navigate(setUrl(location.pathname, searchParams, "category", value));
      } else {
        setShowSubCategories(true);
        navigate(setUrl(location.pathname, searchParams, "category", null));
        setQueryArray([]);
      }
    } catch (error) {
      console.error('handleBack error:', error);
    }
  };

  const handleCategoryByLocation = (arr) => {
    try {
      let newSelectedCategories = [];

             if (Array.isArray(allCategories) && allCategories.length && arr[0]) {
         const parent = allCategories.filter((cat) => cat && cat.c_name && cat.c_name === arr[0]);
         if (parent && parent[0]) {
           newSelectedCategories = [parent[0]];
         }
       }

      for (let i = 0; i < arr.length - 1; i++) {
        if (newSelectedCategories[i] && newSelectedCategories[i].children) {
          const child = newSelectedCategories[i].children?.filter(
            (item) => item?.c_name === arr[i + 1]
          );
          if (child && child[0]) {
            newSelectedCategories.push(child[0]);
          }
        }
      }

      setSelectedCategories(newSelectedCategories);

      if (newSelectedCategories[arr.length - 1]?.children?.length) {
        setCategoryList(newSelectedCategories[arr.length - 1]?.children);
      } else {
        setCategoryList([]);
      }
    } catch (error) {
      console.error('handleCategoryByLocation error:', error);
      setSelectedCategories([]);
      setCategoryList([]);
    }
  };

  useEffect(() => {
    if (search) {
      searchRef.current.focus();
    } else {
      setSearchVal("");
    }
  }, [search]);

  const handleSearchVal = (e) => {
    setSearchVal(e.target.value);
  };

  useEffect(() => {
    // Skip category processing during Alibaba searches
    if (isAlibabaSearch) {
      console.log('Skipping category processing during Alibaba search');
      return;
    }
    
    try {
      if (Array.isArray(selectedCategories) && selectedCategories.length > 0) {
        const lastCategory = selectedCategories[selectedCategories.length - 1];
        if (lastCategory && lastCategory.contentId) {
          setContentId(lastCategory.contentId);
        } else {
          setContentId("");
        }
      } else {
        setContentId("");
      }
    } catch (error) {
      console.error('ProductFilteration useEffect error:', error);
      setContentId("");
    }
  }, [selectedCategories.length, isAlibabaSearch]);

  return (
    <div className="product_filteration_section">
      <div className="filter_search_container">
        <div className="filter_search_head_row">
          <h1 className="filter_heading">CATEGORIES</h1>
          <div
            className="filter_search_icon"
            onClick={() => handleSearch(true)}
          >
            {searchIcon}
          </div>
        </div>

        {search ? (
          <div className="filter_searchbar">
            <input
              type="text"
              ref={searchRef}
              onChange={handleSearchVal}
              value={searchVal}
            />
            <span onClick={() => handleSearch(false)}>{closeIcon}</span>
          </div>
        ) : null}

        {selectedCategories.map((category, index) => {
          return (
            <div className="selected_category_row">
              {category?.children?.length &&
              showSubCategories &&
              selectedCategories.length === index + 1 ? (
                <span onClick={() => selectCategory(category, index)}>
                  {downVIcon}
                </span>
              ) : (
                <span onClick={() => handleBack(category, index)}>
                  {prevVIcon}
                </span>
              )}

              <p key={index} onClick={() => selectCategory(category, index)}>
                {category?.c_name}
              </p>
            </div>
          );
        })}

        <div
          className="filter_items_list"
          style={{ paddingLeft: selectedCategories.length ? "1.2rem" : "" }}
        >
                     {showSubCategories &&
             categoryList
               ?.filter((item) =>
                 item?.c_name?.toLowerCase().includes(searchVal.toLowerCase())
               )
               ?.slice(0, sliceVal)
               ?.map((item, index) => {
                 return (
                   <div className="filter_item" key={index}>
                     <p onClick={() => selectCategory(item)}>{item?.c_name}</p>
                   </div>
                 );
               })}

          {categoryList?.length > sliceVal ? (
            <p
              className="plus_more_btn"
              onClick={() => setSliceVal(categoryList.length)}
            >
              + {categoryList.length - sliceVal} more
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Categories;
